import { message } from "antd"

export function success(alert = "Guardado correctamente!"){
  message.success(alert)
}

export function warning(alert = "Error")
{
  message.error(alert)
}

export function warningBudget(alert = "No se pueden eliminar conceptos relacionados en el apartado de Consultores")
{
  message.error(alert)
}

export function loadingAlert(alert = "Guardando...", duration = 0){
  return message.loading(alert, duration)
}
